import { render, staticRenderFns } from "./TeleMarketDetail.vue?vue&type=template&id=9d29511c&scoped=true"
import script from "./TeleMarketDetail.vue?vue&type=script&lang=js"
export * from "./TeleMarketDetail.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketDetail.vue?vue&type=style&index=0&id=9d29511c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d29511c",
  null
  
)

export default component.exports